// SPDX-License-Identifier: MIT
import { EllipticCurveCryptography } from '../../ecc';
import { SLIP10Ed25519Point as _SLIP10Ed25519Point } from './point';
import { SLIP10Ed25519PublicKey as _SLIP10Ed25519PublicKey } from './public-key';
import { SLIP10Ed25519PrivateKey as _SLIP10Ed25519PrivateKey } from './private-key';
export class SLIP10Ed25519ECC extends EllipticCurveCryptography {
    static NAME = 'SLIP10-Ed25519';
    static ORDER = BigInt('7237005577332262213973186563042994240857116359379907606001950938285454250989');
    static GENERATOR = _SLIP10Ed25519Point.fromCoordinates(BigInt('15112221349535400772501151409588531511454012693041857206046113283949847762202'), BigInt('46316835694926478169428394003475163141307993866256225615783033603165251855960'));
    static POINT = _SLIP10Ed25519Point;
    static PUBLIC_KEY = _SLIP10Ed25519PublicKey;
    static PRIVATE_KEY = _SLIP10Ed25519PrivateKey;
}
export { _SLIP10Ed25519Point as SLIP10Ed25519Point, _SLIP10Ed25519PublicKey as SLIP10Ed25519PublicKey, _SLIP10Ed25519PrivateKey as SLIP10Ed25519PrivateKey };
//# sourceMappingURL=index.js.map